import { GetUserDataWaitingRoom } from '~/domain/usecases/waitingRoom/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from '~/domain/errors';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import '~/infra/global/variables';

export class RemoteGetUserDataWaitingRoom implements GetUserDataWaitingRoom {
  private readonly url: string;

  private readonly httpClient: HttpClient<GetUserDataWaitingRoom.Model>;

  constructor(
    url: string,
    httClient: HttpClient<GetUserDataWaitingRoom.Model>,
  ) {
    this.url = url;
    this.httpClient = httClient;
  }

  getUserData = async (
    params: GetUserDataWaitingRoom.Params,
  ): Promise<GetUserDataWaitingRoom.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url
        .replace('{appointmentId}', `${params.appointmentId}`)
        .replace('{userId}', `${params.userId}`),
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
